import React from 'react';
import LocationTemplate from './LocationTemplate';

const MoreheadCityPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Morehead City"
      stateName="North Carolina"
      countyName="Carteret"
      zipCodes={["28557"]}
      latitude={34.7321}
      longitude={-76.7326}
      population={8661}
      historicalFact="Known as the 'Port City,' it serves as a major fishing port and gateway to the Crystal Coast."
      nearbyTowns={[
        "Beaufort, NC",
        "Atlantic Beach, NC",
        "Emerald Isle, NC",
        "Newport, NC",
        "Pine Knoll Shores, NC",
        "Salter Path, NC",
        "Harkers Island, NC",
        "Cape Carteret, NC"
      ]}
    />
  );
};

export default MoreheadCityPage;